<template>
  <div class="infoModalContainer">
    <div class="header">
      <p class="title">{{ $t('flipCoinTheGame') }}</p>
      <img class="close" src="/img/icons/bone_close.svg" alt="close" @click="getOut" />
    </div>
    <div class="body">
      <div v-for="(section, index) in flipSections" :key="index" class="section">
        <h3 v-html="$t(`flipCoinInfoHeader${section.header}`)"></h3>
        <ul>
          <li v-for="item in section.items" :key="item" v-html="$t(`flipCoinInfo${item}`)"></li>
        </ul>
        <hr class="custom-hr" />
      </div>
      <h3>{{ $t('flipCoinInfoGoodLuck') }}</h3>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['go-to-stats', 'get-out']);

const flipSections = ref([
  { header: 1, items: [11, 12, 13] },
  { header: 2, items: [21, 22] },
  { header: 3, items: [31, 32] },
  { header: 4, items: [41, 42, 43] }
]);

const getOut = () => {
  emit('get-out');
};
</script>

<style lang="scss" scoped>
.infoModalContainer {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  margin: 0 auto;
  z-index: 9999;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 20px;

  .title {
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    color: #fff;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 80%;
    margin: 0 auto;
  }

  .close {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.body {
  text-align: center;
  font-size: 20px;
  color: #fff;
  max-height: 400px;
  overflow-y: scroll;

  h3 {
    font-size: 18px;
    font-weight: 700;
  }

  .section {
    padding-top: 20px;

    ul {
      list-style: none;
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      position: relative;
      text-align: center;
      padding: 0px 30px;

      li {
        margin-bottom: 0.5em;

        ::v-deep(span) {
          color: #88e1ff;
        }

        &::before {
          content: '• ';
          font-size: 0.9em;
          margin-right: 6px;
        }
      }
    }

    hr.custom-hr {
      border: none;
      height: 1px;
      background: linear-gradient(to right, transparent, rgba(255, 223, 128, 0.2), transparent);
      margin: 20px auto;
      width: 60%;
    }
  }
}
</style>
